import { api } from "../ApiState";
import { IApiResponse } from "../../Types/ApiResponse.model";

export const bankApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBankAccountList: builder.query<
      IApiResponse<any>,
      { search?: object; page?: number; deleted?: boolean }
    >({
      query: ({ search, page, deleted }) => ({
        url: "bank-account/list",
        method: "GET",
        params: {
          ...(search && { search: JSON.stringify({ ...search }) }),
          ...(page && { page }),
          ...(deleted && { deleted }),
        },
      }),
      providesTags: ["bankAccount"],
    }),

    getBankAccount: builder.query<any, number>({
      query: (id) => ({
        url: `bank-account/${id}`,
        method: "GET",
      }),
      transformResponse(baseQueryReturnValue: IApiResponse) {
        return baseQueryReturnValue?.response?.data;
      },
      providesTags: ["bankAccount"],
    }),

    storeBankAccount: builder.mutation<any, any>({
      query: (data) => ({
        url: "bank-account",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => (result ? [{ type: "bankAccount" }] : []),
    }),

    updateBankAccount: builder.mutation<
      IApiResponse<any>,
      { id: number; value: object }
    >({
      query: ({ id, value }) => ({
        url: `bank-account/${id}`,
        method: "POST",
        body: { ...value, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "bankAccount" }] : []),
    }),

    deleteBankAccount: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `bank-account/${id}`,
        method: "POST",
        body: { _method: "DELETE" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "bankAccount" }] : []),
    }),

    getBankList: builder.query<IApiResponse<any>, void>({
      query: () => ({
        url: "bank/list",
        method: "GET",
      }),
    }),

    checkIban: builder.mutation<IApiResponse<any>, string>({
      query: (iban) => ({
        url: "iban-inquiry",
        method: "POST",
        body: { iban: iban },
      }),
    }),

    // change status
    pendingBankAccountStatus: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `bank-account/change-status-to-pending/${id}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "bankAccount" }] : []),
    }),

    acceptedAccountStatus: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `bank-account/change-status-to-accepted/${id}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "bankAccount" }] : []),
    }),

    rejectedBankAccountStatus: builder.mutation<
      IApiResponse<any>,
      { id: number; comment: any }
    >({
      query: ({ id, comment }) => ({
        url: `bank-account/change-status-to-rejected/${id}`,
        method: "POST",
        body: { _method: "PUT", comment: comment },
      }),
      invalidatesTags: (result) => (result ? [{ type: "bankAccount" }] : []),
    }),
  }),
});

export const {
  useGetBankAccountListQuery,
  useGetBankAccountQuery,
  useStoreBankAccountMutation,
  useUpdateBankAccountMutation,
  useDeleteBankAccountMutation,
  useGetBankListQuery,
  useCheckIbanMutation,
  usePendingBankAccountStatusMutation,
  useAcceptedAccountStatusMutation,
  useRejectedBankAccountStatusMutation,
} = bankApi;

export default bankApi;
